import {COMPACT_HEADER_TOP_HEIGHT} from '@vio/atlas/Header'
import {CUSTOM_HEADER_HEIGHT} from '@vio/shared/src/whiteLabel/CustomHeader'
import {HEADER_HEIGHT_MOBILE} from 'components/Layouts/mobileStyles'
import {toggle} from 'opticks'

import {useBrand} from '@daedalus/core/src/_web/brand/hooks/useBrand'

export const useTopHeaderHeight = (isMobile = false) => {
  const {brandHasCustomHeader} = useBrand()
  const isNewTopBarExperimentEnabled = toggle(
    '1c5ad789-mobile-top-bar',
    false,
    true
  )

  if (brandHasCustomHeader) return CUSTOM_HEADER_HEIGHT

  if (isMobile) return isNewTopBarExperimentEnabled ? 0 : HEADER_HEIGHT_MOBILE

  return COMPACT_HEADER_TOP_HEIGHT
}
